<div class="route-component">
    <div class="search-component">
        <h4>
            Audit Logs
        </h4>

        <p>Details of this particular activity.</p>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button type="button" class="button-back" (click)="onBack()">
                        <i class="fas fa-arrow-left"></i> Back To Audit Logs
                    </button>
                </div>
            </div>
        </div>

        <app-audit-request ></app-audit-request>
        <app-audit-error ></app-audit-error>
        <app-audit-response ></app-audit-response>
    </div>
</div>